/* Z21 product card - thumbnail swap and thumbnail strip paging.
   Delegated from the document so cards rendered inside the mega menu keep
   working after Shopify re-renders the header section in the theme editor. */
document.addEventListener('click', (event) => {
  const thumb = event.target.closest('.z21-card__thumb');

  if (thumb) {
    const card = thumb.closest('.z21-card');
    if (!card) return;

    const main = card.querySelector('.z21-card__main');
    if (main && thumb.dataset.full) main.src = thumb.dataset.full;

    card.querySelectorAll('.z21-card__thumb').forEach((el) => el.classList.remove('is-active'));
    thumb.classList.add('is-active');
    return;
  }

  const next = event.target.closest('.z21-card__thumbs-next');
  if (!next) return;

  const track = next.parentElement.querySelector('.z21-card__thumbs-track');
  if (track) track.scrollLeft += 130;
});
